import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { dAPI } from 'appSrc/api';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import { PrimaryButton, Icon } from 'appSrc/components/UI';
import { Dropdown } from 'semantic-ui-react';
import { LoadingOverlay } from 'appSrc/components/Shards';
import ImportDropZone from './ImportDropZone';
import PickScheduleModal from './PickScheduleModal';
import BlockModal from './BlockModal';
import BlockWizard from '../BlockWizard';
import ScheduleBlock from './ScheduleBlock';
import ScheduledProsModal from './ScheduledProsModal';
import RerunWizard from '../RerunWizard';
import SidePanel from '../SidePanel';
import { blockSetFactory } from '../utils';
import { Popup } from 'semantic-ui-react';
import style from './styles/style.module.css';


class SchedulePlanner extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            fetching: true,
            schedule: {},
            blocks: [],
            importMode: false,
            selectMode: false,
            selectedBlocks: [],
            editing: false,
            showCsvImport: false,
            showSchedulePicker: false,
            showScheduledPros: false,
            showRerunWizard: false,
            showBlockWizard: false,
        };

        this.scheduleId = this.props.match.params.sid;
        this.scheduleMap = {};
    }
    componentDidMount() {
        this.loadSchedule();

        this.loadOtherScheduleData();
    }
    componentDidUpdate( prevProps, prevState ) {
        if( !this.state.fetching && prevState.fetching !== this.state.fetching ) {
            // fetching is done, so everything should now be rendered
            // check to see if we need to scroll somewhere
            var query = Object.decodeURLQuery( window.location.search );
            if( query.scrollTo ) {
                var id = query.scrollTo;
                var el = document.getElementById( id );
                if( el ) {
                    el.scrollIntoView();
                    el.dataset.focused = true;
                }
            }
        }
    }
    loadOtherScheduleData = () => {
        dAPI.get( '/admin/dltv/schedules' )
        .then( ( response ) => {
            this.scheduleMap = response.reduce( ( ag, item ) => {
                item.runDate = moment.tz( item.run_date, 'MM/DD/YYYY', 'America/Chicago' );
                ag[ item.run_date ] = item;
                return ag;
            }, {} );
        } );
    }
    loadSidePanel = () => {
        const { sidePanel } = this.props;

        sidePanel.add( this.renderSideBarOptions() );
    }
    loadSchedule = () => {
        dAPI.get( `/admin/dltv/schedules/${ this.scheduleId }` )
        .then( ( response ) => {
            var blocks = [];
            if( response.blocks && response.blocks.length > 0 ) {
                blocks = this.validate( response.blocks );
            }
            this.setState( {
                fetching: false,
                schedule: response,
                blocks: blocks,
                importMode: false,
            } );
        } );
    }
    togglePublish = () => {
        dAPI.patch( `/admin/dltv/schedules/${ this.scheduleId }`, {
            published: !this.state.schedule.published,
        } );

        this.setState( ( state ) => {
            state.schedule.published = !this.state.schedule.published;
            return state;
        } );
    }
    onImportClose = () => {
        this.setState( { showCsvImport: false } );
    }
    onImportSubmit = ( newBlocks ) => {
        this.setState( {
            blocks: newBlocks,
            importMode: true,
            showCsvImport: false,
            selectMode: false,
        } );
    }
    validate = ( blocks ) => {
        return blockSetFactory( blocks );
    }
    saveImport = () => {
        this.setState( { fetching: true } );
        let blocks = [ ...this.state.blocks ];

        return dAPI.patch( `/admin/dltv/schedules/${ this.scheduleId }/bulk`, {
            add: blocks,
        } )
        .then( ( newSch ) => {
            let blocks = [];
            if( newSch.blocks && newSch.blocks.length > 0 ) {
                blocks = this.validate( newSch.blocks );
            }
            this.setState( {
                fetching: false,
                schedule: newSch,
                blocks: blocks,
                importMode: false,
            } );
        } );
    }
    makeBlock = ( schId, block ) => {
        var blockData = { ...block };
        var videoData = { ...block.video };
        blockData.id = undefined;
        blockData.schedule_id = undefined;
        blockData.video = undefined;
        videoData.id = undefined;
        videoData.block_id = undefined;

        return dAPI.post( `/admin/dltv/schedules/${ schId }`, {
            video: videoData,
            schedule_block: blockData,
        } );
    }
    closeBlockModal = () => {
        this.setState( { editing: false } );
    }
    showNewBlockModal = () => {
        this.setState( { editing: 'new' } );
    }
    initBlockEdit = ( blockId ) => {
        var blocks = this.state.blocks;
        var index = blocks.findIndex( ( block ) => ( block.id == blockId ) );
        this.editBlock = { ...blocks[ index ] };
        this.setState( { editing: this.editBlock } );
    }
    submitBlockModal = ( task, data ) => {
        var blocks = [ ...this.state.blocks ];
        if( task == 'editing' ) {
            // finished editing, are we importing?
            if( this.state.importMode ) {
                // we are importing, update in place
                var index = blocks.findIndex( ( block ) => ( block.id == this.editBlock.id ) );
                blocks[ index ] = { ...data };
                this.editBlock = {};
                this.setState( {
                    blocks: blocks,
                    editing: false,
                } );
            } else {
                // not importing, update the db
                return dAPI.patch( `/admin/dltv/schedule-blocks/${ this.editBlock.id }`, { data } )
                .then( ( newBlock ) => {
                    var index = blocks.findIndex( ( block ) => ( block.id == this.editBlock.id ) );
                    blocks[ index ] = { ...newBlock };
                    blocks = this.validate( blocks );
                    this.editBlock = {};
                    this.setState( {
                        blocks: blocks,
                        editing: false,
                    } );
                } );
            }
        } else if( task == 'creating' ) {
            // we just made a new one! let's add it in
            var videoData = { ...data.video };
            var blockData = { ...data };
            delete blockData.video;

            return dAPI.post( `/admin/dltv/schedules/${ this.state.schedule.id }`, {
                video: videoData,
                schedule_block: blockData,
            } )
            .then( ( newBlock ) => {
                blocks.push( { ...newBlock } );
                blocks = this.validate( blocks );
                this.editBlock = {};
                this.setState( {
                    blocks: blocks,
                    editing: false,
                    showBlockWizard: false,
                } );
            } );
        } else if( task == 'deleting' ) {
            // we're deleting this, and that's final!
            return dAPI.delete( `/admin/dltv/schedule-blocks/${ this.editBlock.id }` )
            .then( () => {
                this.setState( { editing: false, fetching: true } );
                this.loadSchedule();
            } );
        }
        return Promise.resolve();
    }
    initCopyBlock = ( block ) => {
        this.copyingBlock = { ...block };
        this.setState( { showSchedulePicker: true } );
    }
    submitSchedulePick = ( date ) => {
        var y, m, d, key;
        y = date.year();
        m = date.month();
        d = date.date();
        key = date.format( 'MM/DD/YYYY' );

        this.copyingBlock.startTime = moment.tz( this.copyingBlock.start_time, 'America/Chicago' )
        .year( y ).month( m ).date( d );

        this.copyingBlock.endTime = moment.tz( this.copyingBlock.end_time, 'America/Chicago' )
        .year( y ).month( m ).date( d );

        this.copyingBlock.start_time = this.copyingBlock.startTime.format();
        this.copyingBlock.end_time = this.copyingBlock.endTime.format();

        var scheduleId = this.scheduleMap[ key ].id;

        var videoData = {
            ...this.copyingBlock.video,
            id: undefined,
            block_id: undefined,
            is_live: false,
        };
        var blockData = {
            ...this.copyingBlock,
            id: undefined,
            video: undefined,
        };

        return dAPI.post( `/admin/dltv/schedules/${ scheduleId }`, {
            video: videoData,
            schedule_block: blockData,
        } )
        .then( ( newBlock ) => {
            var newState = { showSchedulePicker: false };
            if( newBlock.schedule_id == this.state.schedule.id ) {
                newState.blocks = this.validate( [ ...this.state.blocks, newBlock ] );
            }
            this.copyingBlock = {};
            this.setState( newState );
        } );
    }
    showScheduledPros = () => {
        var proNames = [];
        this.scheduledPros = this.state.schedule.blocks.reduce( ( agg, block ) => {
            var video = block.video || {};
            var proName = ( video.pro_name || '' ).trim();
            if( !proNames.includes( proName ) ) {
                proNames.push( proName );
                agg.push( [ proName, ( video.pro_email || '' ).trim() ] );
            }
            return agg;
        }, [] );
        this.setState( { showScheduledPros: true } );
    }
    //selectMode functions
    toggleSelectMode = () => {
        this.setState( {
            selectedBlocks: [],
            selectMode: !this.state.selectMode,
        } );
    }
    selectClick = ( e ) => {
        let newState = e.target.checked;
        let blockId = e.target.value;
        let selectedBlocks = [ ...this.state.selectedBlocks ];

        if( this.lastChecked !== undefined && e.shiftKey ) {
            // check a group of items
            let x = this.state.blocks.findIndex( block => block.id.toString() == blockId );
            let y = this.state.blocks.findIndex( block => block.id.toString() == this.lastChecked );

            let start = Math.min( x, y );
            let end = Math.max( x, y ) + 1;
            let ids = this.state.blocks.slice( start, end ).map( block => block.id.toString() );

            if( newState ) {
                // if we're checking the last one, then we're checking them all
                selectedBlocks.push( ...ids );
            } else {
                // uncheck the lot of them
                selectedBlocks = selectedBlocks.filter( blockId => !ids.includes( blockId ) );
            }
            selectedBlocks = [ ...new Set( selectedBlocks ) ];
        } else {
            // check a single item
            if( newState ) {
                selectedBlocks.push( blockId );
            } else {
                let i = selectedBlocks.indexOf( blockId );
                if( i !== -1 ) {
                    selectedBlocks.splice( i, 1 );
                }
            }
        }
        this.lastChecked = blockId;
        this.setState( { selectedBlocks } );
    }
    deleteGroup = () => {
        let conf = window.confirm( 'Are you sure you want to delete the selected items?' );
        if( conf ) {
            this.setState( { fetching: true } );
            let blockIds = [ ...this.state.selectedBlocks ];

            return dAPI.patch( `/admin/dltv/schedules/${ this.scheduleId }/bulk`, {
                remove: blockIds,
            } )
            .then( ( newSch ) => {
                let blocks = [];
                if( newSch.blocks && newSch.blocks.length > 0 ) {
                    blocks = this.validate( newSch.blocks );
                }
                this.setState( {
                    fetching: false,
                    schedule: newSch,
                    blocks: blocks,
                    importMode: false,
                } );
            } );
        }
    }
    // Re-run Wizard invocation
    showRerunWizard = () => {
        let selectedBlocks = [ ...this.state.selectedBlocks ];
        this.rerunBlocks = this.state.blocks.filter( block => selectedBlocks.includes( block.id.toString() ) );
        this.setState( { showRerunWizard: true } );
    }
    hideRerunWizard = ( completed ) => {
        this.rerunBlocks = [];
        if( completed ) {
            this.loadSchedule();
            this.loadOtherScheduleData();
        }
        this.setState( { showRerunWizard: false } );
    }





    render() {
        const { schedule, blocks, importMode, selectMode } = this.state;
        const errorsPresent = blocks.findIndex( item => ( Object.keys( item.errors || {} ).length > 0 ) ) !== -1;
        const runDate = moment.utc( schedule.run_date, 'MM/DD/YYYY' );


        return (
            <section className={ style.schedulePlanner }>
                <Helmet>
                    <title>Admin - DLTV Schedule Planner</title>
                </Helmet>
                { this.sidePanel() }
                <div className={ style.head }>
                    <div>
                        <h2>DLTV Schedule Planner</h2>
                        <h3>{ runDate.format( 'dddd, MM-DD-YYYY' ) }</h3>
                    </div>
                    { importMode &&
                        <div className={ style.buttonGroup }>
                            <PrimaryButton label='Cancel Import'
                            style={ { backgroundColor: '#F44336' } }
                            onClick={ this.loadSchedule } />
                            <PrimaryButton label='Save Import'
                            className={ style.save }
                            onClick={ this.saveImport } />
                        </div>
                    }
                    { selectMode &&
                        <div>
                            <Dropdown text='Actions' className={ style.selectActions }
                            button icon={ ( <Icon source='fontAwesome' icon='fas/faCaretDown' /> ) }
                            direction='left'
                            disabled={ this.state.selectedBlocks.length == 0 }>
                                <Dropdown.Menu>
                                    <Dropdown.Item text='Re-run Selected' onClick={ this.showRerunWizard } />
                                    <Dropdown.Item text='Delete Selected' onClick={ this.deleteGroup } />
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    }
                </div>
                <div className={ style.body }>
                    <div className={ style.tableWrapper }>
                        <div className={ style.timesTable }>
                            <div className={ style.tr }>
                                <div className={ style.th }
                                style={ { color: 'blue', display: selectMode ? undefined : 'none' } }>Select</div>

                                <div className={ style.th }
                                style={ { color: 'red', display: errorsPresent ? undefined : 'none' } }>Errors</div>

                                <div className={ `${ style.th } ${ style.date }` }>Date</div>
                                <div className={ `${ style.th } ${ style.date }` }>Start Time</div>
                                <div className={ `${ style.th } ${ style.date }` }>End Time</div>
                                <div className={ style.th }>Duration</div>
                                <div className={ style.th }>Category</div>
                                <div className={ style.th }>Persist?</div>
                                <div className={ style.th }>Video Link</div>
                                <div className={ style.th }>Cover Image</div>
                                <div className={ `${ style.th } ${ style.title }` }>Title</div>
                                <div className={ style.th }>Pro</div>
                                <div className={ style.th }>Pro Title</div>
                                <div className={ `${ style.th } ${ style.description }` }>Description</div>
                                <div className={ style.th }>Donation Link</div>
                                <div className={ style.th }>Related Content Link</div>
                                <div className={ style.th }>Sponser</div>
                                <div className={ style.th }>Sponser Link</div>
                            </div>
                            { blocks.map( ( block, index ) => {
                                let props = { block, runDate, errorsPresent, selectMode };

                                return (
                                    <ScheduleBlock key={ block.id } { ...props }
                                    onEditInit={ this.initBlockEdit }
                                    onCopyInit={ this.initCopyBlock }
                                    onSelectClick={ this.selectClick }
                                    scheduleOptions={ this.state.schedules }
                                    selected={ this.state.selectedBlocks.includes( block.id.toString() ) }
                                    tabIndex={ index + 20 } />
                                );
                            } ) }
                        </div>
                    </div>
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
                <ImportDropZone runDate={ runDate } visible={ this.state.showCsvImport }
                closeHandler={ this.onImportClose } onSubmit={ this.onImportSubmit } />

                <BlockModal block={ this.state.editing } run_date={ runDate.format( 'MM/DD/YYYY' ) }
                onTaskComplete={ this.submitBlockModal }
                closeHandler={ this.closeBlockModal } visible={ !!this.state.editing } />

                <PickScheduleModal visible={ this.state.showSchedulePicker }
                include={ Object.values( this.scheduleMap ).map( sch => sch.runDate.hours(14).utc().toDate() ) }
                onSubmit={ this.submitSchedulePick }
                closeHandler={ () => { this.setState( { showSchedulePicker: false } ); } }/>

                <ScheduledProsModal visible={ this.state.showScheduledPros }
                pros={ this.scheduledPros }
                closeHandler={ () => { this.setState( { showScheduledPros: false } ); } } />

                <RerunWizard visible={ this.state.showRerunWizard }
                blocks={ this.rerunBlocks } schedules={ this.scheduleMap }
                closeHandler={ this.hideRerunWizard } />

                <BlockWizard visible={ this.state.showBlockWizard } run_date={ runDate.format( 'MM/DD/YYYY' ) }
                closeHandler={ () => { this.setState( { showBlockWizard: false } ); } }
                onSubmit={ this.submitBlockModal } />
            </section>
        );
    }


    sidePanel = () => {
        const { schedule } = this.state;
        let pubTitle = ( schedule.published ? 'Un-' : '' ) + 'Publish';
        let pubIcon = ( schedule.published ? 'far/faCalendarCheck' : 'far/faCalendarTimes' );

        return (
            <SidePanel>
                <ul className={ style.plannerOptions }>
                    <li title='Go to Schedules Page'>
                        <Link to='/admin/dltv'>
                            <span className='wide'>
                                <Icon source='fontAwesome' icon='fas/faAngleLeft' className={ style.angleLeft } />
                                <Icon source='fontAwesome' icon='far/faCalendarAlt' />&nbsp;&nbsp;<span>Schedules</span>
                            </span>
                            <span className='narrow'>
                                <Icon source='fontAwesome' icon='fas/faAngleLeft' className={ style.angleLeft } />
                                <Icon source='fontAwesome' icon='far/faCalendarAlt' />
                            </span>
                        </Link>
                    </li>
                </ul>
                <ul className={ style.plannerOptions }>
                    <li onClick={ this.togglePublish } title={ pubTitle }>
                        <span className='wide'><Icon source='fontAwesome' icon={ pubIcon } />&nbsp;&nbsp;<span>{ pubTitle }</span></span>
                        <span className='narrow'><Icon source='fontAwesome' icon={ pubIcon } /></span>
                    </li>

                    <li onClick={ () => { this.setState( { showCsvImport: true } ); } } title='Import CSV'
                    data-active={ this.state.importMode }>
                        <span className='wide'><Icon source='fontAwesome' icon='fas/faFileImport' />&nbsp;&nbsp;<span>Import CSV</span></span>
                        <span className='narrow'><Icon source='fontAwesome' icon='fas/faFileImport' /></span>
                    </li>

                    { !this.state.importMode &&
                        <li onClick={ this.toggleSelectMode } title='Select Mode'
                        data-active={ this.state.selectMode }>
                            <span className='wide'><Icon source='fontAwesome' icon='fas/faTasks' />&nbsp;&nbsp;<span>Select Mode</span></span>
                            <span className='narrow'><Icon source='fontAwesome' icon='fas/faTasks' /></span>
                        </li>
                    }
                </ul>
                <ul className={ style.plannerOptions }>
                    <li onClick={ () => { this.setState( { editing: 'new' } ); } } title='Add Schedule Block'>
                        <span className='wide'><Icon source='fontAwesome' icon='fas/faPlus' />&nbsp;&nbsp;<span>Add Block</span></span>
                        <span className='narrow'><Icon source='fontAwesome' icon='fas/faPlus' /></span>
                    </li>

                    <li onClick={ () => ( this.setState( { showBlockWizard: true } ) ) } title='Schedule Wizard'>
                        <span className='wide'><Icon source='fontAwesome' icon='fas/faMagic' />&nbsp;&nbsp;<span>Schedule Wizard</span></span>
                        <span className='narrow'><Icon source='fontAwesome' icon='fas/faMagic' /></span>
                    </li>
                </ul>
                <ul className={ style.plannerOptions }>
                    <li onClick={ this.showScheduledPros } title='Show Scheduled Pros'>
                        <span className='wide'><Icon source='fontAwesome' icon='fas/faUserClock' />&nbsp;&nbsp;<span>Scheduled Pros</span></span>
                        <span className='narrow'><Icon source='fontAwesome' icon='fas/faUserClock' /></span>
                    </li>
                </ul>
                <ul className={ style.plannerOptions }>
                    <li>
                        <Popup className={ style.errorPopup }
                        trigger={ (
                            <div>
                                <span className='wide'>
                                    <Icon source='fontAwesome' icon='far/faQuestionCircle' />&nbsp;&nbsp;<span>Legend</span>
                                </span>
                                <span className='narrow'>
                                    <Icon source='fontAwesome' icon='far/faQuestionCircle' />
                                </span>
                            </div>
                        ) }
                        on={ ['hover', 'click'] }
                        position='right center' >
                            <Popup.Header className={ style.popupHeader }>
                                Legend:
                            </Popup.Header>
                            <Popup.Content className={ style.popupContent }>
                                <div style={ { backgroundColor: 'lime', padding: '5px' } }>Live</div>
                                <div style={ { backgroundColor: '#EAE8E4', padding: '5px' } }>Hidden</div>
                                <div style={ { backgroundColor: 'lightblue', padding: '5px' } }>Highlighted</div>
                            </Popup.Content>
                        </Popup>
                    </li>
                </ul>
            </SidePanel>
        );
    }
}

export default SchedulePlanner;
